export default __webpack_public_path__ + "static/media/Chevron_Down.30553f4b.svg";